import { array } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Request = <GroupingField extends string>(groupingFields: readonly GroupingField[]) =>
	array(iotsUtils.fromList(groupingFields));
